import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4">
      <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full text-center space-y-6 animate-in fade-in zoom-in duration-500">
        
        {/* Success Icon with Pulse Effect */}
        <div className="relative inline-block">
          <div className="absolute inset-0 bg-green-100 rounded-full animate-ping opacity-75"></div>
          <div className="relative bg-green-50 rounded-full p-3">
            <CheckCircleIcon className="h-16 w-16 text-green-500" />
          </div>
        </div>

        {/* Text Content */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Payment Successful!</h1>
          <p className="text-gray-500 text-sm">
            Thank you for upgrading to Pro. Your account has been updated with premium features.
          </p>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-100 w-full"></div>

        {/* Redirection Info & Button */}
        <div className="space-y-4">
          <p className="text-sm text-gray-400 font-medium">
            Redirecting to dashboard in <span className="text-indigo-600 font-bold">{timeLeft}s</span>...
          </p>
          
          <button 
            onClick={() => navigate('/dashboard')}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-4 rounded-xl transition-all duration-200 transform hover:scale-[1.02] shadow-md shadow-indigo-200 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Go to Dashboard Now
          </button>
        </div>

      </div>
    </div>
  );
};

export default PaymentSuccess;